import { useState } from "react";
import { AnimatePresence, LayoutGroup, motion } from "framer-motion";
import { CONSULTANTS } from "@/data/team";
import { ConsultantCard } from "@/components/sections/ConsultantCard";
import { EASE } from "@/components/ui/motion";

const ROLES = ["Semua", "Senior Executive", "Senior Partner", "Senior Client Service"];

const Filter = ({ value, onChange }) => (
  <div className="-mx-5 flex gap-2 overflow-x-auto px-5 pb-1 [scrollbar-width:none] sm:mx-0 sm:flex-wrap sm:px-0 [&::-webkit-scrollbar]:hidden" role="tablist" aria-label="Filter jabatan konsultan" data-testid="team-filter" data-lenis-prevent-horizontal>
    {ROLES.map((r) => {
      const count = r === "Semua" ? CONSULTANTS.length : CONSULTANTS.filter((c) => c.role === r).length;
      const active = value === r;
      return (
        <button
          key={r}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(r)}
          className={`relative shrink-0 whitespace-nowrap rounded-full px-4 py-2.5 text-[13px] font-semibold transition-colors duration-300 ${active ? "text-white" : "border border-line bg-white text-slateb hover:border-sky-brand"}`}
          data-testid={`team-filter-${r.toLowerCase().replace(/\s+/g, "-")}`}
        >
          {active && <motion.span layoutId="team-filter-pill" className="absolute inset-0 rounded-full bg-slateb" transition={{ type: "spring", stiffness: 380, damping: 32 }} />}
          <span className="relative flex items-center gap-2">
            {r}
            <span className={`rounded-full px-1.5 text-[11px] ${active ? "bg-sky-brand text-ink" : "bg-ice text-accentb"}`}>{count}</span>
          </span>
        </button>
      );
    })}
  </div>
);

export const TeamGrid = ({ exclude, limit, filter = false }) => {
  const [role, setRole] = useState("Semua");
  const list = CONSULTANTS.filter((c) => c.slug !== exclude && (role === "Semua" || c.role === role)).slice(0, limit);
  return (
    <LayoutGroup>
      {filter && <Filter value={role} onChange={setRole} />}
      <motion.ul layout className={`grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 ${filter ? "mt-10" : ""}`} data-testid="staff-grid">
        <AnimatePresence initial={false}>
          {list.map((c) => (
            <ConsultantCard
              key={c.slug}
              c={c}
              layout
              exit={{ opacity: 0, scale: 0.92, transition: { duration: 0.3, ease: EASE } }}
              transition={{ layout: { duration: 0.6, ease: EASE } }}
            />
          ))}
        </AnimatePresence>
      </motion.ul>
    </LayoutGroup>
  );
};
